<div class="main-container-position">
  <div class="container-width">
    <div class="justify-center mb-20">
      <div>
        <div class="flex justify-center mt-10 mb-5">
          <div
            class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 bg-none sm:bg-gray-200 rounded-full p-2 sm:p-0"
          >
            <button
              class="py-3 px-6 sm:py-4 sm:px-8 rounded-full font-bold focus:outline-none w-full sm:w-auto text-center"
              [ngClass]="
                activeSection === 'section1'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 text-gray-800'
              "
              (click)="toggle('section1')"
            >
              <span class="material-symbols-outlined align-middle"
                >settings_applications</span
              >
              <span class="ml-2" i18n>Kategorienverwaltung</span>
            </button>
            <button
              class="py-3 px-6 sm:py-4 sm:px-8 rounded-full font-bold focus:outline-none w-full sm:w-auto text-center"
              [ngClass]="
                activeSection === 'section2'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 text-gray-800'
              "
              (click)="toggle('section2')"
            >
              <span class="material-symbols-outlined align-middle"
                >manage_accounts</span
              >
              <span class="ml-2" i18n>User Management</span>
            </button>
          </div>
        </div>

        @if (activeSection === "section1") {
          <div>
            <div class="p-4 rounded-xl" style="background-color: #f2f6f9">
              <div class="p-4 pb-8 flex flex-row w-full">
                <div class="flex items-center">
                  <span class="text-xl font-bold" i18n>Kategorien</span>
                </div>
                <div class="ml-auto">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="addRootCategory()"
                    class="py-2 px-4 outline outline-gray-500 rounded-full"
                  >
                    <div class="flex items-center">
                      <mat-icon>add</mat-icon>
                      @if (!isMobileView) {
                        <span class="ml-2" i18n>Neue Kategorie hinzufügen</span>
                      }
                      @if (isMobileView) {
                        <span class="" i18n></span>
                      }
                    </div>
                  </button>
                </div>
              </div>
              <div class="px-4">
                @if (isLoadingCategories) {
                  <div class="flex justify-center my-8">
                    <app-loading-indication
                      size="medium"
                      displayText="Kategorien werden geladen..."
                    ></app-loading-indication>
                  </div>
                }
                @if (!isLoadingCategories) {
                  <mat-tree
                    [dataSource]="dataSource"
                    [treeControl]="treeControl"
                  >
                    <mat-nested-tree-node *matTreeNodeDef="let node">
                      <div class="mat-tree-node">
                        <!-- Expand / Collapse toggle if node has children -->
                        <!-- <button mat-icon-button matTreeNodeToggle *ngIf="hasChild(0, node)"
                              [attr.aria-label]="'Toggle ' + node.name">
                              <mat-icon>
                                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                              </mat-icon>
                            </button> -->
                        <!-- Node name -->
                        <!-- Add indentation and chevron for child nodes -->
                        @if (!getNodeLevel(node).isRoot) {
                          <div
                            class="inline-block"
                            [style.marginLeft.px]="
                              getNodeLevel(node).level * 24
                            "
                          >
                            <mat-icon class="align-middle"
                              >chevron_right</mat-icon
                            >
                          </div>
                        }
                        {{ node.name }}
                        <!-- Context menu trigger button -->
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="menu"
                          aria-label="Actions"
                          class="ml-auto"
                        >
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <!-- Context menu -->
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="editCategory(node)">
                            <mat-icon>edit</mat-icon>
                            <span>Bearbeiten</span>
                          </button>
                          @if (getNodeLevel(node).level === 0) {
                            <button
                              mat-menu-item
                              (click)="addSubcategory(node)"
                            >
                              <mat-icon>add</mat-icon>
                              <span>Unterkategorie hinzufügen</span>
                            </button>
                          }
                          <button mat-menu-item (click)="deleteCategory(node)">
                            <mat-icon color="warn">delete</mat-icon>
                            <span>Löschen</span>
                          </button>
                        </mat-menu>
                      </div>
                      <!-- Children are rendered here if expanded -->
                      <div [class.invisible]="!treeControl.isExpanded(node)">
                        <hr />
                        <ng-container matTreeNodeOutlet></ng-container>
                      </div>
                    </mat-nested-tree-node>
                  </mat-tree>
                }
              </div>
              <!-- Add a new root-level category -->
              <!-- <button mat-raised-button color="primary" (click)="addRootCategory()">
                  Add New Root Category
                </button> -->
            </div>
          </div>
        }

        @if (showDeleteModal) {
          <div
            class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center"
          >
            <div
              class="bg-white w-full max-w-sm p-6 rounded-lg shadow-lg mx-4 text-center"
            >
              <h3 class="text-xl font-semibold mb-4" i18n>
                Willst du den User wirklich löschen?
              </h3>
              <p class="text-gray-600 mb-6" i18n>
                Diese Aktion kann nicht rückgängig gemacht werden.
              </p>
              <div class="flex justify-between space-x-4">
                <button
                  (click)="closeDeleteModal()"
                  class="px-4 py-2 bg-gray-300 text-black font-semibold rounded-full"
                  i18n
                >
                  Abbrechen
                </button>
                <button
                  (click)="confirmDeleteUser()"
                  class="px-4 py-2 bg-red-500 text-white font-semibold rounded-full"
                  i18n
                >
                  Löschen
                </button>
              </div>
            </div>
          </div>
        }

        @if (showModal) {
          <app-category-modal
            [category]="modalCategory"
            (closeModal)="closeModal()"
          ></app-category-modal>
        }

        @if (activeSection === "section2") {
          <div>
            <div class="p-4 rounded-xl" style="background-color: #f2f6f9">
              <div class="flex justify-between items-center mb-4"></div>
              @if (isLoadingUsers) {
                <div class="flex justify-center my-8">
                  <app-loading-indication
                    size="medium"
                    displayText="Benutzer werden geladen..."
                  ></app-loading-indication>
                </div>
              }
              @if (showUserModal) {
                <div
                  class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center"
                >
                  <div
                    class="bg-white w-full max-w-2xl p-6 rounded-lg shadow-lg mx-4"
                    style="max-height: 90vh; overflow-y: auto"
                  >
                    <h3 class="text-lg font-semibold mb-4">
                      {{
                        isEditing
                          ? "Benutzer bearbeiten"
                          : "Benutzer hinzufügen"
                      }}
                    </h3>
                    <form
                      [formGroup]="userForm"
                      (ngSubmit)="confirmUpdateUser()"
                    >
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <h4
                            class="text-sm font-medium text-gray-700 mb-2"
                            i18n
                          >
                            Informationen
                          </h4>
                          <div class="mb-4">
                            <label
                              for="firstName"
                              class="block text-xs font-medium text-gray-700"
                              i18n
                              >Vorname*</label
                            >
                            <input
                              type="text"
                              formControlName="firstName"
                              class="p-2 border border-gray-300 rounded-md w-full text-xs"
                            />
                            @if (
                              userForm.get("firstName")?.invalid &&
                              userForm.get("firstName")?.touched
                            ) {
                              <div class="text-red-500 text-xs mt-1">
                                Vorname ist erforderlich
                              </div>
                            }
                          </div>
                          <div class="mb-4">
                            <label
                              for="lastName"
                              class="block text-xs font-medium text-gray-700"
                              i18n
                              >Nachname</label
                            >
                            <input
                              type="text"
                              formControlName="lastName"
                              class="p-2 border border-gray-300 rounded-md w-full text-xs"
                            />
                            @if (
                              userForm.get("lastName")?.invalid &&
                              userForm.get("lastName")?.touched
                            ) {
                              <div class="text-red-500 text-xs mt-1">
                                Nachname ist erforderlich
                              </div>
                            }
                          </div>
                          <div class="mb-4">
                            <label
                              for="email"
                              class="block text-xs font-medium text-gray-700"
                              i18n
                              >Email*</label
                            >
                            <input
                              type="email"
                              formControlName="email"
                              class="p-2 border border-gray-300 rounded-md w-full text-xs"
                            />
                            @if (
                              userForm.get("email")?.invalid &&
                              userForm.get("email")?.touched
                            ) {
                              <div class="text-red-500 text-xs mt-1">
                                Gültige E-Mail ist erforderlich
                              </div>
                            }
                          </div>
                          <div class="mb-4">
                            <label
                              for="birthYear"
                              class="block text-xs font-medium text-gray-700"
                              i18n
                              >Geburtsjahr</label
                            >
                            <input
                              type="number"
                              formControlName="birthYear"
                              class="p-2 border border-gray-300 rounded-md w-full text-xs"
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <h4 class="text-sm font-medium text-gray-700 mb-2" i18n>
                          Rolle
                        </h4>
                        <div class="flex flex-col gap-2">
                          <label
                            class="inline-flex items-center text-xs font-medium text-gray-700"
                          >
                            <input
                              type="checkbox"
                              formControlName="hasAdminRole"
                              class="mr-2"
                            />
                            <span i18n>Admin</span>
                          </label>
                          <label
                            class="inline-flex items-center text-xs font-medium text-gray-700"
                          >
                            <input
                              type="checkbox"
                              formControlName="hasCompanyRole"
                              class="mr-2"
                            />
                            <span i18n>Firma</span>
                          </label>
                        </div>
                      </div>
                      <div class="mb-4">
                        <label
                          class="inline-flex items-center text-xs font-medium text-gray-700"
                        >
                          <input
                            type="checkbox"
                            formControlName="isAdvisoryboard"
                            class="mr-2"
                            (change)="toggleAdvisoryTab()"
                          />
                          <span i18n>Teil des Fachbeirats</span>
                        </label>
                      </div>
                      <div class="mb-4">
                        <label
                          class="inline-flex items-center text-xs font-medium text-gray-700"
                        >
                          <input
                            type="checkbox"
                            formControlName="isRegionalAdvisoryboard"
                            class="mr-2"
                          />
                          <span i18n>Teil des regionalen Fachbeirats</span>
                        </label>
                      </div>
                      @if (userForm.get("isAdvisoryboard")?.value) {
                        <div class="mt-6">
                          <h4
                            class="text-sm font-medium text-gray-700 mb-2"
                            i18n
                          >
                            Fachbeiratkategorien festlegen
                          </h4>
                          <div class="flex gap-2 mb-2">
                            <button
                              type="button"
                              class="px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-xs"
                              (click)="selectAllAdvisoryCategories()"
                              [disabled]="areAllAdvisoryCategoriesSelected()"
                              i18n
                            >
                              Alle auswählen
                            </button>
                            <button
                              type="button"
                              class="px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-xs"
                              (click)="clearAllAdvisoryCategories()"
                              [disabled]="
                                (
                                  $any(
                                    userForm.get('advisoryCategories')?.value
                                  ) || []
                                ).length === 0
                              "
                              i18n
                            >
                              Auswahl löschen
                            </button>
                          </div>
                          <mat-form-field class="w-full">
                            <mat-select
                              formControlName="advisoryCategories"
                              multiple
                            >
                              @for (category of allCategories; track category) {
                                <mat-option [value]="category.id">{{
                                  category.name
                                }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <div class="mt-6">
                            <h4 class="text-sm font-medium text-gray-700 mb-2">
                              Fachbeirat Regionen (Ausschlüsse)
                            </h4>
                            <app-advisory-bezirk-selector
                              [selectedBezirkIds]="
                                $any(userForm.get('advisoryBezirkIds')?.value)
                              "
                              (selectedBezirkIdsChange)="
                                userForm
                                  .get('advisoryBezirkIds')
                                  ?.setValue($event)
                              "
                            ></app-advisory-bezirk-selector>
                          </div>
                        </div>
                      }
                      <div class="flex justify-end mt-6 space-x-2">
                        <button
                          type="button"
                          (click)="closeUserModal()"
                          class="px-3 py-1 bg-gray-300 text-black font-semibold rounded-full text-xs"
                          [disabled]="isSavingUser"
                        >
                          Abbrechen
                        </button>
                        <button
                          type="submit"
                          class="px-3 py-1 bg-blue-500 text-white font-semibold rounded-full text-xs disabled:bg-gray-300 disabled:text-gray-600"
                          [disabled]="isSavingUser || userForm.invalid"
                        >
                          @if (!isSavingUser) {
                            {{ isEditing ? "Speichern" : "Hinzufügen" }}
                          }
                          @if (isSavingUser) {
                            <span class="flex items-center">
                              <app-loading-indication
                                size="small"
                              ></app-loading-indication>
                              <span class="ml-2">Speichern...</span>
                            </span>
                          }
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              }
              <div
                class="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3 px-2"
              >
                <div class="w-full md:w-1/2">
                  <label
                    for="userSearch"
                    class="block text-xs font-medium text-gray-700 mb-1"
                    i18n
                    >Suche</label
                  >
                  <input
                    id="userSearch"
                    type="text"
                    [(ngModel)]="userSearchTerm"
                    class="w-full px-3 py-2 border border-gray-300 rounded-full text-xs focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Vorname, Nachname oder E-Mail suchen"
                    i18n-placeholder
                  />
                </div>
                <div class="flex items-center text-xs text-gray-700">
                  <input
                    id="fachbeiratOnly"
                    type="checkbox"
                    [(ngModel)]="showOnlyAdvisoryboard"
                    class="mr-2"
                  />
                  <label for="fachbeiratOnly" i18n
                    >Nur Fachbeirat anzeigen</label
                  >
                </div>
              </div>
              <div class="overflow-x-auto">
                <table
                  class="min-w-full table-fixed bg-white border border-gray-200"
                >
                  <thead>
                    <tr class="bg-gray-100">
                      <th
                        class="w-1/6 px-4 py-2 border-b border-gray-200 text-left text-sm font-semibold text-gray-700"
                        i18n
                      >
                        Vorname
                      </th>
                      <th
                        class="w-1/6 px-4 py-2 border-b border-gray-200 text-left text-sm font-semibold text-gray-700"
                        i18n
                      >
                        Nachname
                      </th>
                      <th
                        class="w-1/6 px-4 py-2 border-b border-gray-200 text-left text-sm font-semibold text-gray-700"
                        i18n
                      >
                        E-Mail
                      </th>
                      <th
                        class="w-1/6 px-4 py-2 border-b border-gray-200 text-left text-sm font-semibold text-gray-700"
                        i18n
                      >
                        Firma
                      </th>
                      <th
                        class="w-1/6 px-4 py-2 border-b border-gray-200 text-left text-sm font-semibold text-gray-700"
                        i18n
                      >
                        PLZ
                      </th>
                      <th
                        class="w-1/12 px-4 py-2 border-b border-gray-200 text-center text-sm font-semibold text-gray-700"
                        i18n
                      >
                        Fachbeirat
                      </th>
                      <th
                        class="w-1/12 px-4 py-2 border-b border-gray-200 text-center text-sm font-semibold text-gray-700"
                        i18n
                      >
                        Regionaler Fachbeirat
                      </th>
                      <th
                        class="w-1/12 px-4 py-2 border-b border-gray-200 text-center text-sm font-semibold text-gray-700"
                        i18n
                      >
                        Änderungen
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of filteredUsers; track user) {
                      <tr class="hover:bg-gray-50 h-20">
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900"
                        >
                          {{ user.firstName }}
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900"
                        >
                          {{ user.lastName }}
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900"
                        >
                          {{ user.email }}
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900"
                        >
                          <div class="flex items-center">
                            <span class="material-symbols-outlined mr-2">
                              {{
                                user.roles?.includes("COMPANY")
                                  ? "check"
                                  : "close"
                              }}
                            </span>
                          </div>
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900"
                        >
                          {{ user.zipCode }}
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900 text-center"
                        >
                          @if (user.isAdvisoryboard) {
                            <span class="material-symbols-outlined">check</span>
                          }
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900 text-center"
                        >
                          @if (user.isRegionalAdvisoryboard) {
                            <span class="material-symbols-outlined">check</span>
                          }
                        </td>
                        <td
                          class="px-4 py-2 border-b border-gray-200 text-sm text-gray-900 text-center"
                        >
                          <div
                            class="flex items-center justify-center space-x-2"
                          >
                            <button
                              (click)="openUserModal(user)"
                              class="text-blue-500 hover:text-blue-700"
                            >
                              <span class="material-symbols-outlined"
                                >edit</span
                              >
                            </button>
                            <button
                              (click)="openDeleteModal(user.id)"
                              class="text-red-500 hover:text-red-700"
                            >
                              <span class="material-symbols-outlined"
                                >delete</span
                              >
                            </button>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="flex justify-center mt-6">
                <button
                  (click)="loadMoreUsers()"
                  [disabled]="!hasMoreUsers || (isLoadingUsers && hasMoreUsers)"
                  i18n
                  class="px-4 md:px-6 py-2 bg-blue-500 text-white rounded-full shadow-md hover:bg-blue-600 disabled:bg-gray-300 flex items-center space-x-2"
                >
                  @if (!isLoadingUsers) {
                    <span>Mehr anzeigen</span>
                  }
                  @if (isLoadingUsers) {
                    <span class="flex items-center">
                      <app-loading-indication
                        size="small"
                      ></app-loading-indication>
                      <span class="ml-2">Laden...</span>
                    </span>
                  }
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
